// /frontend/src/components/JobCard.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
    Typography, Box, Chip, Button, Card, CardContent, CardActions, 
    CircularProgress, Snackbar, Alert 
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';

const JobCard = ({ job }) => {
  const navigate = useNavigate();
  const [applying, setApplying] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  // Funzione per navigare al dettaglio dell'annuncio
  const handleViewDetails = () => {
    navigate(`/opportunita/${job.id}`);
  };

  // Funzione per la candidatura rapida
  const handleQuickApply = async (e) => {
    e.stopPropagation(); // Impedisce al click di propagarsi alla card e navigare
    setApplying(true);
    try {
      const res = await axios.post(`/api/jobs/${job.id}/apply`);
      setAlert({ open: true, message: res.data.message, severity: 'success' });
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Si è verificato un errore.';
      setAlert({ open: true, message: errorMessage, severity: 'error' });
    } finally {
      setApplying(false);
    }
  };

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };

  return (
    <>
      <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%', transition: '0.3s', '&:hover': { boxShadow: 6 } }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {job.title}
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', mb: 2 }}>
            <BusinessIcon sx={{ mr: 1, fontSize: '1rem' }} />
            <Typography variant="body2">{job.business.name}</Typography>
            <LocationOnIcon sx={{ ml: 2, mr: 1, fontSize: '1rem' }} />
            <Typography variant="body2">{job.location}</Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            {job.categories.map(({ category }) => (
              <Chip key={category.name} label={category.name} size="small" sx={{ mr: 1, mb: 1 }} />
            ))}
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ 
              display: '-webkit-box', 
              WebkitLineClamp: 3, 
              WebkitBoxOrient: 'vertical', 
              overflow: 'hidden',
              textOverflow: 'ellipsis' 
          }}>
            {job.description}
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
  <Button size="small" onClick={handleViewDetails}>Dettagli</Button>
  {job.hasApplied ? (
    <Button size="small" variant="outlined" disabled>Già Candidato</Button>
  ) : (
    <Button 
      size="small" 
      variant="contained" 
      onClick={handleQuickApply}
      disabled={applying}
    >
      {applying ? <CircularProgress size={20} color="inherit" /> : 'Candidati'}
    </Button>
  )}
</CardActions>
      </Card>

      {/* Componente per mostrare i messaggi di successo o errore */}
      <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default JobCard;